import React, {useEffect} from 'react'
import {useParams} from "react-router";
import Loading from "components/Loading";
import GridBlock from "components/GridBlock";
import {connect} from "react-redux";
import scrollTo from "libs/scrollTo";
import PropTypes from "prop-types";
import DemandOffersAuctionService from "services/DemandOffersAuctionService";
import {StageSectionsUrlParams} from "../../../constants/StageSections";
import {OfferMode} from "../../common/constants/OfferMode";
import GeneralInfoEntry from "../generalInfo/components/GeneralInfoEntry";
import Tr from "translations/Translations";
import OfferContractorData from "../../common/contractorData/OfferContractorData";
import AuctionsTable from "./components/AuctionsTable";


function AuctionOfferEditPanel(
    {
        panelRef,
        sectionId,
        demandHeader,
        offerAuctionsListData
    }) {

    const params = useParams();
    const demandId = params.id;
    const stageId = params.stageId;
    const section = params.section;
    const mode = section === StageSectionsUrlParams.AUCTION_OFFER_EDIT ? OfferMode.EDIT : OfferMode.PLACED;

    const dataLoading = !offerAuctionsListData || !demandHeader;
    useEffect(() => {
            if (!dataLoading) {
                setTimeout((elem) => scrollTo(elem), 100, panelRef.current);
            }
        }
        // eslint-disable-next-line
        , [dataLoading])

    useEffect(() => {
        DemandOffersAuctionService.getOfferAuctionsList(demandId, stageId, mode)
        return () => {
            DemandOffersAuctionService.clearResources(DemandOffersAuctionService.OFFER_AUCTIONS_LIST_DATA);
        }
    }, [demandId, stageId, section, mode])


    return dataLoading ? <Loading/> :
        <GridBlock column>
            <GeneralInfoEntry label={Tr('contractor_data')}>
                <OfferContractorData offerEdit={offerAuctionsListData}/>
            </GeneralInfoEntry>

            <AuctionsTable auctions={offerAuctionsListData.auctions} demandId={demandId} stageId={stageId} />

        </GridBlock>
}

AuctionOfferEditPanel.propTypes = {
    sectionId: PropTypes.string.isRequired
}

export default connect((state) => ({
    demandHeader: state.resources.demandHeader,
    offerAuctionsListData: state.resources[DemandOffersAuctionService.OFFER_AUCTIONS_LIST_DATA],
}), {})(AuctionOfferEditPanel);